import create from "zustand";
import { persist } from "zustand/middleware"

let date = new Date().toISOString().substr(0, 10)

try {
  date = window.location.pathname?.match(/\d{4}-\d{2}-\d{2}/)?.[0] || new Date().toLocaleDateString('fr-ca')
} catch {
  date = new Date().toISOString().substr(0, 10)
}

const team = window.location.pathname.match(/\/teams\/[a-z0-9]+/i)?.[0]?.replace('/teams/', '')

const callback = (set, get) => ({
  free: false,
  noshow: true,
  cancelled: true,
  reschedule: false,
  date,
  update: payload => set(() => ({ ...payload })),
  setEvent: event => set(() => ({ event })),
  setLocation: (location) => set((state) => ({ location })),
  setResource: (resource) => set((state) => ({ resource })),
  // Cuando el recurso se aplica desde afuera (ej: #resourceID al entrar al calendario)
  // se bloquea la preselección automática del filtro de profesionales.
  resourceLocked: false,
  setService: (service) => set((state) => ({ service })),
  setFinancier: (financier) => set((state) => ({ financier })),
  clear: () => set(state => ({
    clearAt: Date.now(),
    resourceLocked: false,
    resource: null,
    location: null,
    service: null,
    financier: null,
    free: false,
    noshow: true,
    cancelled: true
  })),
  toggle: (key) => set((state) => ({ [key]: !state[key] })),
  // Bug real (auditoría 2026-08-16, cleanup): acción muerta — cero callers en
  // todo src/ (los `.refetch()` que existen en la app son todos el método de
  // react-query sobre queries individuales, no esta acción de zustand) y
  // `refetchAt` tampoco se leía en ningún selector real. Se quitó junto con
  // los selectores `isFetched`/`refetchAt` de Calendar.js.
  reset: () => set(() => ({
    event: undefined,
    reschedule: undefined,
    refetchAt: undefined
  }))
})

let useStore

if (team) {
  const options = {
    name: `${team}-events-storage`,
    // `slot`: bandera efímera ("hay un form de turno abierto ahora mismo",
    // ver Slot.js/Calendar.js) — nunca debe sobrevivir a un reload/nueva
    // sesión, igual que clearAt/resourceLocked de acá abajo.
    partialize: state => ({ ...state, date: undefined, updatedAt: undefined, clearAt: undefined, resourceLocked: undefined, slot: undefined })
  }
  useStore = create(persist(callback, options))
} else {
  useStore = create(callback)
}


export default useStore;
